module.exports = __webpack_public_path__ + "static/media/services-img5.18394448.jpg";